module.exports = __webpack_public_path__ + "static/media/nurse-svgrepo-com.f3ae5797.svg";